/**
 * Language: Français.
 */
export default {
    time: {
        openingHoursTitle: "Horaires d'ouverture",
        at: "à",
        opensToday: "Ouvre aujourd'hui",
        opens: "Ouvre",
        open24_7: "Ouvert 24/7",
        closed: "Fermé",
        openUntil: "Ouvert jusqu'à",
        daily: "Ouvert tous les jours",
        month: [
            'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
        ],
        monthAbbr: [
            'Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin',
            'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'
        ],
        dayOfWeek: [
            'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'
        ],
        dayOfWeekAbbr: [
            'Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'
        ],
        eventCountdown: "Prochain événement dans",
        days: "jours",
        hours: "heures",
        tomorrow: "Prochain événement demain",
        today: "aujourd'hui"
    },
    search: {
        placeholder: "Rechercher un lieu...",
        submitLabel: "Rechercher",
        clearLabel: "Effacer la recherche",
        yourLocation: "Votre position",
    },
    filtering: {
        servicesTitle: "Filtrer",
        services: {
            AR: 'Archery',
            ARG: 'Artistic Gymnastics',
            ARS: 'Artistic Swimming',
            ATH: 'Athletics',
            BDM: 'Badminton',
            BKB: 'Basketball',
            BK3: '3x3 Basketball',
            BV: 'Beach Volleyball',
            BOX: 'Boxing',
            BKG: 'Breaking',
            CSL: 'Canoe Slalom',
            CSP: 'Canoe Sprint',
            BMF: 'Cycling BMX Freestyle',
            BMX: 'Cycling BMX Racing',
            MTB: 'Cycling Mountain Bike',        
            CRD: 'Cycling Road',
            CTR: 'Cycling Track',
            DIV: 'Diving',
            EQU: 'Equestrian',
            FEN: 'Fencing',
            FB: 'Football',
            GLF: 'Golf',
            HBL: 'Handball',
            HOC: 'Hockey',
            JUD: 'Judo',
            OWS: 'Marathon Swimming',
            MPN: 'Modern Pentathlon',
            GRY: 'Rhythmic Gymnastics',
            ROW: 'Rowing',
            RU7: 'Rugby Sevens',
            SAL: 'Sailing',
            SHO: 'Shooting',
            SKB: 'Skateboarding',
            CLB: 'Sport Climbing',
            SRF: 'Surfing',
            SWM: 'Swimming',
            TTE: 'Table Tennis',
            TKW: 'Taekwondo',
            TEN: 'Tennis',
            GTR: 'Trampoline Gymnastics',
            TRI: 'Triathlon',
            VVO: 'Volleyball',
            WPO: 'Water Polo',
            WLF: 'Weightlifting',
            WRE: 'Wrestling'
        }
    },
    stores: {
        cta: {
            call: "Appeler",
            directions: "Itinéraire",
            website: "Site Web"
        },
        messages: {
            initialHeader: "Chercher une localité pour afficher les sites à proximité",
            emptyHeader: "Aucun résultat retourné",
            initialBody: "ou sélectionner un site via la carte",
            emptyBody: "Rechercher ailleurs or désactiver vos filtres"
        },
        types: {
            major: "Lieux de célébration",
            minor: "Lieux visité"
        },
        name: {
            Stage: "Etape"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Autoroutes',
            tolls: 'Péages',
            ferries: 'Transbordeurs'
        },
        avoidTransitOptions: {
            "train": "Train",
            "bus": "Bus",
            "ferries": "Transbordeurs",
            "aerial": "Aérien"
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'milles'
        },
        options: "Options d'itinéraire",
        avoid: "Éviter",
        units: "Unités de distance",
        messages: {
            initialBody: "Renseigner une origine et une destination pour voir les itinéraires disponible et le temps de trajet.",
            error: "Désolé, impossible de calculer l'itinéraire",
            from: "de",
            to: "à",
            forTravelMode: "pour le mode de transport",
            via: "via",
            details: "Details",
            withoutTraffic: "sans circulation",
            openGoogleMaps: "ouvrir dans Google Maps",
            take: "Prendre",
            walk: "Marcher",
            the: "le"
        },
        transit : {
            "train": "train",
            "bus": "bus",
            "ferries": "transbordeurs",
            "aerial": "aérien",
            "tram": "tram",
            "rail": "train",
        }
    },
    errors: {
        loadingLibrary: "Impossible de charger le script {library}",
        geolocationFailed: "Impossible de géolocaliser l'utilisateur",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    map: {
        showRoute: "Afficher l'itinéraire"
    }
};
